import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { makeTimelineItemHash } from 'flow-doctor-lib/utils/timelineItemUtils';
const getTimelineItemForClassicReenrollment = ({
  enrollmentLogEvent,
  timelineLogItems
}) => {
  const classicTriggerType = enrollmentLogEvent.contextMap.CLASSIC_TRIGGER;
  switch (classicTriggerType) {
    case 'CONTACT_PROPERTY_NAME':
      return timelineLogItems.find(item => item.type === 'PROPERTY_CHANGE');
    case 'DYNAMIC_LIST':
      return timelineLogItems.find(item => item.type === 'LIST_MEMBERSHIP');
    case 'FORM':
      return timelineLogItems.find(item => item.type === 'FORM_SUBMISSION');
    default:
      return null;
  }
};
const useHighlightTimelineItem = ({
  timelineLogItems
}) => {
  const history = useHistory();
  const enrollmentLogEvent = timelineLogItems[0] && timelineLogItems[0].data;
  useEffect(() => {
    const itemToHash = (() => {
      if (!enrollmentLogEvent) {
        return null;
      }

      // First item in the timeline should be the enrollment event we're focused on diagnosing, so these casts are safe
      switch (enrollmentLogEvent.enrollType) {
        case 'EVENT_ENROLL':
          // An event enroll either is a UE, or a list membership "list trigger" event
          return timelineLogItems.find(item => item.type === 'UNIFIED_EVENT') || timelineLogItems.find(item => item.type === 'LIST_MEMBERSHIP');
        case 'ACTION_EXECUTION_ENROLL':
          // Should just be the action execution log event in this case
          return timelineLogItems.find(item => item.type === 'ACTION_EXECUTION_LOG_EVENT');
        case 'RE_ENROLL':
          {
            const isClassicReenrollment = enrollmentLogEvent.objectTypeId === '0-1';
            if (isClassicReenrollment) {
              return getTimelineItemForClassicReenrollment({
                enrollmentLogEvent,
                timelineLogItems
              });
            }

            // Highlight the most recent list membership if re-enrollment was caused by persisted re-enrollment list
            if (enrollmentLogEvent.contextMap.LIST_ID) {
              return timelineLogItems.find(item => item.type === 'LIST_MEMBERSHIP');
            }

            // All other platform cases must be UE-based
            return timelineLogItems.find(item => item.type === 'UNIFIED_EVENT');
          }
        default:
          return null;
      }
    })();
    if (itemToHash) {
      history.replace(Object.assign({}, history.location, {
        hash: makeTimelineItemHash(itemToHash)
      }));
    }
  }, [timelineLogItems, enrollmentLogEvent, history]);
};
export default useHighlightTimelineItem;